let cachedWebGLSupported: boolean | null = null;

export const isWebGLSupported = (): boolean => {
  if (typeof window === 'undefined') return false;
  if (cachedWebGLSupported !== null) return cachedWebGLSupported;

  try {
    const canvas = document.createElement('canvas');
    const gl = (
      canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
    ) as WebGLRenderingContext | null;

    const supported = !!(window.WebGLRenderingContext && gl);

    if (gl) {
      const loseContext = gl.getExtension('WEBGL_lose_context');
      if (loseContext) {
        loseContext.loseContext();
      }
    }

    cachedWebGLSupported = supported;
    return supported;
  } catch (e) {
    cachedWebGLSupported = false;
    return false;
  }
};

let cachedLowEndDevice: boolean | null = null;

export const isLowEndDevice = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  if (cachedLowEndDevice !== null) return cachedLowEndDevice;

  // Check device memory (RAM in GB). Less than 4GB is considered low-end.
  // @ts-ignore
  const memory = navigator.deviceMemory;
  if (memory && memory < 4) {
    cachedLowEndDevice = true;
    return true;
  }

  // Check CPU cores. Less than 4 cores is considered low-end.
  const cores = navigator.hardwareConcurrency;
  if (cores && cores < 4) {
    cachedLowEndDevice = true;
    return true;
  }

  cachedLowEndDevice = false;
  return false;
};
